import { getHeaderHeight } from './getHeaderHeight';

export const scrollToElement = $element => {
  let scrollTop =  $element.offset().top - getHeaderHeight() - 20;
  if ($('.menu-wrapper.sticky').length === 0) {
    scrollTop =  $element.offset().top - 80;
  }
  $('html, body').animate({ scrollTop }, 400);
};
